import React, { useEffect, useMemo, useState } from "react";
import close from "../../../../assets/img/icons/Vector copy.svg";
import CountBox from "../../../dropbox/CountBox";
import IconBox from "../../../shared/IconBox";
import mines from "../../../../assets/img/icons/Vector.svg";
import add from "../../../../assets/img/icons/add.svg";
import Button from "../../../shared/Button";
import { useForm } from "react-hook-form";
import Input from "../../../shared/Input";
import trash from "../../../../assets/img/icons/trash.svg";

const AddHeatModal = ({ closeModal, setcustomSleep, customSleep }) => {

  const {
    handleSubmit,
    formState: { errors, isValid },

    control,
    reset
  } = useForm();
 
  const onSubmit = data => {
   

      setcustomSleep(prev => [...prev, { value: data.name }]);
      reset({ name: "" });
   
  };



  
 const submitEdit = ()=>{

 }

  return (
    <div className="ModalBackground PlaceCapModal">
      <div className="ModalBackground--container p-[25px]">
        <div className="flex justify-between  items-center">
          <h2 className="text-[#292D32] text-[20px] font-[700]">
            سایر موارد : مثل تخت تاشو و ...
          </h2>
          <button onClick={closeModal}>
            <img src={close} />
          </button>
        </div>
        <hr className="my-[20px]" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            name="name"
            control={control}
            errors={errors}
            placeholder=" امکان رفاهی  مورد نظر را وارد کنید"
            className="seconadary-input"
            register={{
              required: "امکان رفاهی  مورد نظر را وارد کنید"
            }}

          />
          <Button varient='fifth' fullwidth={true} className='my-[20px]'>افزودن </Button>
         
        
        </form>
        <hr className="my-[20px]" />

        {customSleep.map(i =>
          <div key={i.value} className="flex customsleepItem">
            <div className="w-[20px] h-[20px] customsleepItem-checkitem " />
            <p>
              {i.value}
            </p>
          <div className="flex items-center">
        
          </div>
          </div>
        )}

        <div className="flex gap-[12px] mt-[25px]">
          <Button varient="white" fullwidth onClick={()=>{closeModal();setcustomSleep([])}}>
            انصراف
          </Button>
          <Button varient="primary" onClick={closeModal} fullwidth>
            تایید{" "}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddHeatModal;
